<div mat-dialog-title class="onboarding-title">{{'onboarding.title' | translate}}</div>
<mat-dialog-content class="onboarding-content">
  <mat-stepper orientation="horizontal" [linear]="true" labelPosition="bottom" #stepper>
    <mat-step>
      <ng-template matStepContent>
        <div class="step-content">
          <mat-icon class="step-icon">new_releases</mat-icon>
          <h2>{{'onboarding.step1.title' | translate}}</h2>
          <p>{{'onboarding.step1.text' | translate}}</p>
          <div class="step-actions">
            <button mat-flat-button matStepperNext color="primary">{{'onboarding.next' | translate}}</button>
          </div>
        </div>
      </ng-template>
    </mat-step>

    <mat-step>
      <ng-template matStepContent>
        <div class="step-content">
          <mat-icon class="step-icon">design_services</mat-icon>
          <h2>{{'onboarding.step2.title' | translate}}</h2>
          <p>{{'onboarding.step2.text' | translate}}</p>
          <div class="step-actions">
            <button mat-button matStepperPrevious>{{'onboarding.back' | translate}}</button>
            <button mat-flat-button matStepperNext color="primary">{{'onboarding.next' | translate}}</button>
          </div>
        </div>
      </ng-template>
    </mat-step>

    <mat-step>
      <ng-template matStepContent>
        <div class="step-content">
          <mat-icon class="step-icon">support_agent</mat-icon>
          <h2>{{'onboarding.step3.title' | translate}}</h2>
          <p [innerHTML]="'onboarding.step3.text' | translate"></p> 
          <div class="step-actions">
            <button mat-button matStepperPrevious>{{'onboarding.back' | translate}}</button>
            <button mat-flat-button color="primary" (click)="finishOnboarding()">{{'onboarding.finish' | translate}}</button>
          </div>
        </div>
      </ng-template>
    </mat-step>
  </mat-stepper>
</mat-dialog-content>
<mat-dialog-actions class="onboarding-actions">
  <button mat-button (click)="skipOnboarding()">{{'onboarding.skip' | translate}}</button>
</mat-dialog-actions> 